// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__5r18Q","title":"Header_title__1R_Py","left":"Header_left__3SkK7","clinicName":"Header_clinicName__3XqZt"};